<template>
    <div class="checkout-fields">
        <div class="cart-details-container flex">
            <div class="billing-details-container">
                <h6>Billing Details</h6>
                <p>
                    <strong>Name:</strong> {{ cart.billingInfo.first_name }}
                    {{ cart.billingInfo.last_name }}
                </p>
                <p><strong>Phone:</strong> {{ cart.billingInfo.phone }}</p>
                <p><strong>Email:</strong> {{ cart.billingInfo.email }}</p>

                <p>
                    <strong>Billing Address:</strong> <br />
                    {{ cart.billingInfo.address1 }}, <br />
                    {{ cart.billingInfo.suburb }}, {{ cart.billingInfo.city }}, {{ cart.billingInfo.post_code }}<br/>
                    <!-- Remove delivery Req
                        {{ getRegionName(cart.billingInfo.region_id) }},
                        {{ getCountryName(cart.billingInfo.country_id) }} -->
                </p>
            </div>

            <div class="shipping-details-container">
                <h6>Shipping Details</h6>
                <p>
                    <strong>Name:</strong> {{ cart.shippingInfo.first_name }}
                    {{ cart.shippingInfo.last_name }}
                </p>
                <p><strong>Phone:</strong> {{ cart.shippingInfo.phone }}</p>
                <p><strong>Email:</strong> {{ cart.shippingInfo.email }}</p>
                <p>
                    <strong>Address:</strong> <br />
                    {{ cart.shippingInfo.address1 }}, <br />
                    {{ cart.shippingInfo.suburb }}, {{ cart.shippingInfo.city }}, {{ cart.shippingInfo.post_code }}<br />
                    <!-- Remove delivery Req
                        {{ getRegionName(cart.shippingInfo.region_id) }},
                        {{ getCountryName(cart.shippingInfo.country_id) }} -->
                </p>
            </div>
        </div>

        <div class="module-checkout-order-summary">
            <table>
                <tbody>
                    <tr
                        class="line-item-row"
                        v-for="item in cart.items"
                        v-bind:key="item.id"
                    >
                        <td>
                            <img
                                alt="Product Title"
                                class="lazyload"
                                :src="item.image"
                            />
                        </td>
                        <td>
                            <p class="title">{{ item.title }}</p>
                            <p class="price">$ {{ item.price }} NZD</p>
                            <p>QTY: {{ item.quantity }}</p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Subtotal
                            <p v-if="cart.gstInclusive">
                                Includes GST of $
                                <span class="js-gst">{{
                                    getFormatAmount(cart.gstAmount)
                                }} NZD</span>
                            </p>
                        </td>
                        <td class="price">
                            <strong
                                >$
                                <span class="js-subtotal">{{
                                    getFormatAmount(cart.subTotalAmount)
                                }} NZD</span></strong
                            >
                        </td>
                    </tr>

                    <tr v-if="!cart.gstInclusive">
                        <td>GST</td>
                        <td class="price">
                            <strong
                                >$
                                <span class="js-subtotal">{{
                                    getFormatAmount(cart.subTotalAmount)
                                }} NZD</span></strong
                            >
                        </td>
                    </tr>

                    <tr>
                        <td>Shipping</td>
                        <td>
                            <strong
                                >$
                                <span class="js-shipping">{{
                                    getFormatAmount(cart.shippingAmount)
                                }}</span></strong
                            >
                        </td>
                    </tr>
                    <tr class="total">
                        <td>Total</td>
                        <td>
                            <strong
                                >$
                                <span class="js-total">{{
                                    getFormatAmount(cart.totalAmount)
                                }} NZD</span></strong
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="accept-me form-field">
            <div class="custom-checkbox-radio">
                <label class="accept-label">
                    <input type="checkbox" v-model="isAccepted" />
                    <a href="/terms-conditions" target="_blank"
                        >Click the checkbox to accept the Terms & Conditions or click here to read</a
                    >
                </label>
            </div>
        </div>

        <div class="checkout-step-footer">
            <button
                @click="goBack()"
                :disabled="disableButton"
                class="button black large"
            >
                BACK
            </button>


            <button
                @click="saveInformation('dps')"
                :disabled="disableButton"
                class="button black large dps-btn"
            >
                Pay with Credit Card
            </button>


            <!-- <button
                @click="saveInformationPaypal('paypal')"
                :disabled="disableButton"
                class="button black large paypal-btn"
            >
                Paypal
            </button> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        countries: Array,
        regions: Array,
        cart: Object
    },
    data() {
        return {
            isAccepted: false,
            disableButton: false
        };
    },
    mounted() {},
    methods: {
        getCountryName(id) {
            if (id) {
                let object = this.countries.find(x => x.id === id);
                if (object) {
                    return object.title;
                }
            }

            return "";
        },
        getRegionName(id) {
            if (id) {
                let object = this.regions.find(x => x.id === id);
                if (object) {
                    return object.name;
                }
            }
            return "";
        },
        getFormatAmount(amount) {

            return parseFloat(amount)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        goBack() {
            this.$emit("emitStep", 2);
        },
        saveInformation(action) {
            if (!this.isAccepted) {
                this.$store.dispatch('toast', 'Please indicate that you have read and agree to the Terms and Conditions')
                return;
            }

            this.disableButton = true;

            window.axios.post("/payments/" + action).then(response => {
                console.log('response', response)
                if (response.data.success) {
                    window.location.href = response.data.url;
                } else {
                    window.location.href = "/payments/cancelled";
                }
            });
        },
        saveInformationPaypal(action) {
            if (!this.isAccepted) {
                this.$store.commit("setPopup", {
                    open: true,
                    content:
                        "Please indicate that you have read and agree to the Terms and Conditions"
                });
                return;
            }

            this.disableButton = true;

            window.axios
                .post("/payments/" + action)
                .then(response => {
                    if (response.success) {
                        window.location.href = response.url;
                    } else {
                        window.location.href = "/declined";
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>
<style lang="scss">

.billing-details-container, .shipping-details.container {
    width: 50%;

    @media (max-width: 768px) {
        width: 100%;
    }
}

.lazyload {
    width: 200px;
    height: auto;

    @media (max-width: 768px) {
        width: 100px;
        height: auto;
    }
}

.accept-label {
    display: flex;
    align-items: center;
    padding: 0 0 15px;
    margin-bottom: 0;

    input {
        margin-top: 0;
    }
}

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/Payment.vue